import React, { useState, useEffect } from 'react';
import PasswordDisplay from './components/PasswordDisplay';
import PasswordSettings from './components/PasswordSettings';
import './App.css';
import iceLogo from './images/11000ad_ice_scaled.png'; // Make sure this path is correct

function App() {
  const [password, setPassword] = useState('');
  const [passwordLength, setPasswordLength] = useState(12);
  const [passwordType, setPasswordType] = useState('all');
  const [includeCapital, setIncludeCapital] = useState(true);
  const [includeLowercase, setIncludeLowercase] = useState(true);
  const [includeNumbers, setIncludeNumbers] = useState(true);
  const [includeSymbols, setIncludeSymbols] = useState(true);

  const generatePassword = () => {
    let charset = '';
    let newPassword = '';

    if (passwordType === 'pronounce') {
      charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    } else if (passwordType === 'read') {
      charset = 'abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    } else {
      if (includeCapital) charset += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      if (includeLowercase) charset += 'abcdefghijklmnopqrstuvwxyz';
      if (includeNumbers) charset += '0123456789';
      if (includeSymbols) charset += '!@#$%^&*()_+~`|}{[]:;?><,./-=';
    }

    for (let i = 0; i < passwordLength; i++) {
      newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
    }

    setPassword(newPassword);
  };

  useEffect(() => {
    generatePassword();
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <div className="App">
      <div className="app-wrapper">
        <h1 className="app-title">Passgenic</h1>
        <h2 className="app-subtitle">The No-Nonsense Password Generator</h2>
        <div className="container">
          <PasswordDisplay
            password={password}
            onGeneratePassword={generatePassword}
          />
          <PasswordSettings
            passwordLength={passwordLength}
            setPasswordLength={setPasswordLength}
            passwordType={passwordType}
            setPasswordType={setPasswordType}
            includeCapital={includeCapital}
            setIncludeCapital={setIncludeCapital}
            includeLowercase={includeLowercase}
            setIncludeLowercase={setIncludeLowercase}
            includeNumbers={includeNumbers}
            setIncludeNumbers={setIncludeNumbers}
            includeSymbols={includeSymbols}
            setIncludeSymbols={setIncludeSymbols}
            onGeneratePassword={generatePassword}
            password={password}  // Add this line
          />
        </div>
        <a href="https://11000ad.com" target="_blank" rel="noopener noreferrer" className="ice-logo-link">
          <img src={iceLogo} alt="11000AD Ice" className="ice-logo" />
        </a>
      </div>
    </div>
  );
}

export default App;